import React, { useEffect, useState } from "react";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { useApiprofilepictureMutation } from "../Store/Middleware/api/profilePictureAPI";
import { toast } from "react-toastify";
import { useApiresumeMutation } from "../Store/Middleware/api/resumeAPI";
import { useApiprofileMutation } from "../Store/Middleware/api/profileAPI";
import { useGetprofileapiQuery } from "../Store/Middleware/api/getProfileAPI";
import Cookies from "js-cookie";
import { UploadFile } from "@mui/icons-material";
import axios from "axios";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const ProfileCard = () => {
  const { data, refetch, isError } = useGetprofileapiQuery();
  const [apiProfile, profileResults] = useApiprofileMutation();
  const [toggleText, setToggleText] = useState(false);
  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [uploadData, setUploadData] = useState({
    profilePicture: "",
    resumeUpload: "",
    showImage: "",
  });

  useEffect(() => {
    if (isError) {
      localStorage.clear();
      Cookies.remove("_secure_ARJ_");
      // window.location.href = "/login";
    }
  }, [data, isError]);

  const token = Cookies?.get("authToken");

  async function handleFileUpload(event) {
    const file = event.target.files[0];

    if (!file) {
      toast.error("No file selected.");
      return;
    }

    const fileSizeInMB = file.size / (1024 * 1024);
    const fileExtension = file.name.split(".").pop()?.toLowerCase();

    if (fileSizeInMB > 6) {
      toast.error("File size exceeds the 6 MB limit.");
      return;
    }

    if (!["pdf", "docx", "txt"].includes(fileExtension)) {
      toast.error(
        "Invalid file format. Only PDF, DOCX, or TXT files are allowed.",
      );
      return;
    }

    const candidateId = localStorage.getItem("candidate_id");

    setUploadData((prev) => ({
      ...prev,
      resumeUpload: file,
    }));

    const formData = new FormData();
    formData.append("candidate_id", candidateId);
    formData.append("resume", file);

    axios
      .post(`${process.env.REACT_APP_API_URL}/user-resume-upload`, formData, {
        headers: {
          authorization: token,
        },
      })
      .then((response) => {
        if (response?.status === 401) {
          localStorage.clear();
          Cookies.remove("_secure_ARJ_");
          // window.location.href = "/login";
        }
        if (response.status === 200) {
          toast.success("Resume Uploaded Successfully");
          refetch();
        } else {
          toast.error(response.message);
        }
      })
      .catch((err) => {
        toast.error(err);
      });
  }

  async function handleProfileUpload(event) {
    const file = event.target.files[0];
    const candidateId = localStorage.getItem("candidate_id");
    if (
      file.type.split("/").includes("jpeg") ||
      file.type.split("/").includes("png") ||
      file.type.split("/").includes("jpg")
    ) {
      const formData = new FormData();
      formData.append("candidate_id", candidateId);
      formData.append("profile_picture", file);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/user/profile-picture/upload`,
        formData,
        {
          headers: {
            authorization: token,
          },
        },
      );
      if (response.status === 201) {
        toast.success(response.data.message);
        refetch();
      } else {
        toast.error("Something went wrong");
      }
    } else {
      toast.error("Profile Picture Upload Failed");
    }
  }

  useEffect(() => {
    setName(data?.message?.details?.name);
    setNumber(data?.message?.details?.mobile);
    const savedImage = localStorage.getItem("profile_picture");
    if (savedImage) {
      setUploadData((prev) => ({
        ...prev,
        showImage: savedImage,
      }));
    }

    setUploadData((prev) => ({
      ...prev,
      profilePicture: data?.message?.details?.profile_path,
      resumeUpload: data?.message?.details?.resume_path,
    }));
  }, [data]);

  const handleSave = async () => {
    if (name === "" || number === "") {
      toast.error("Please fill all the fields");
      return;
    } else if (name?.split(" ").length < 2) {
      toast.error("Please Enter valid Full Name");
      return;
    }

    const response = await apiProfile({
      candidate_id: localStorage.getItem("candidate_id"),
      name,
      number,
      email: localStorage.getItem("userID"),
    });
    if (response?.data?.success) {
      toast.success("Profile Updated Successfully");
    } else {
      toast.error(response.error.data.error);
    }
    setToggleText(!toggleText);
  };

  const handleNameChange = (e) => {
    const value = e.target.value;

    if (value.length <= 50) {
      setName(value);
      localStorage.setItem("name", value);
    }
  };

  const handleNumber = (e) => {
    if (e.target.value.length <= 12) {
      setNumber(e.target.value);
    } else {
      toast.error("Mobile Number should be less than 12 digits");
    }
  };

  useEffect(() => {
    setUploadData((prev) => ({
      ...prev,
      profilePicture: data?.message?.details?.profile_path,
      resumeUpload: data?.message?.details?.resume_path,
    }));
  }, []);

  return (
    <div className="profileCard">
      <div className="profileCard-img-msite">
        <img
          src={
            uploadData?.profilePicture?.replace("profilePicture", "profile") ||
            "/profileImg.png"
          }
          className="profileImg"
          id="profileImage"
        />
        <span className="profileImg-upload">
          <img src={"/upload.png"} />
        </span>
        <label className="profileImg-upload2">
          <input
            type="file"
            style={{ visibility: "hidden" }}
            onChange={handleProfileUpload}
            className="profileImg-upload2-input"
          />
        </label>
      </div>
      <div className="profileCard-b2">
        <div className="profileCard-b2-m1">
          <div className="profileCard-b2-m1-font">
            General Information{" "}
            <BorderColorIcon
              fontSize="medium"
              sx={{
                color: "#165DFF",
              }}
              F
              style={{ cursor: "pointer" }}
              onClick={() => setToggleText(!toggleText)}
            />
          </div>
        </div>
        <div className="profileCard-b2-m2">
          <div>Name</div>:{" "}
          <div className="toggleText-input">
            <div>
              {toggleText ? (
                <div className={`input-group mb-3`}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Name"
                    aria-label="Name"
                    aria-describedby="basic-addon1"
                    onChange={handleNameChange}
                    value={name || localStorage.getItem("name")}
                    style={{ width: "200px" }}
                  />
                </div>
              ) : (
                <>{name}</>
              )}
            </div>{" "}
            {toggleText && (
              <Button
                variant="contained"
                sx={{
                  background: "#165DFF",
                  "&:hover": {
                    background: "#165DFF",
                  },
                }}
                onClick={handleSave}
              >
                Save
              </Button>
            )}
          </div>
        </div>
        <div className="profileCard-b2-m2">
          <div>Email</div>:{" "}
          <div style={{ color: "grey" }}>
            {data?.message?.details?.email || localStorage.getItem("userID")}
          </div>
        </div>
        <div className="profileCard-b2-m2">
          <div>Resume</div>:{" "}
          <div style={{ color: "grey" }}>
            {data?.message?.details?.resume || "N/A"}
          </div>
        </div>
        <div className="profileCard-b2-m2">
          <div>Contact Number</div>:{" "}
          <div className="toggleText-input">
            <div>
              {toggleText ? (
                <div className={`input-group mb-3`}>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Contact Number"
                    aria-label="Contact Number"
                    aria-describedby="basic-addon1"
                    onChange={handleNumber}
                    value={number || localStorage.getItem("number")}
                    style={{ width: "200px" }}
                  />
                </div>
              ) : (
                <>
                  {number
                    ? `+${number}`
                    : localStorage.getItem("number")
                      ? `+${localStorage.getItem("number")}`
                      : ""}
                </>
              )}
            </div>{" "}
          </div>
        </div>
        <div>
          <div className="profileCard-b2-m1-fontResume">Resume</div>
          <div className="profileCard-b2-resume">
            {localStorage.getItem("resume") ||
            data?.message?.details?.resume ? (
              localStorage.getItem("resume") || (
                <Button
                  sx={{
                    fontWeight: "bold",
                    color: "#165DFF !important",
                    borderColor: "#165DFF",
                    "&:hover": {
                      borderColor: "#165DFF",
                    },
                    " @media screen and (max-width: 625px)": {
                      width: "100%",
                    },
                  }}
                  variant="outlined"
                  href={uploadData?.resumeUpload}
                  target="_blank"
                  startIcon={<DescriptionOutlinedIcon />}
                >
                  Download Resume
                </Button>
              )
            ) : (
              <div className="profileCard-b2-resume-m1">
                <DescriptionOutlinedIcon fontSize="large" />{" "}
                {uploadData?.resumeUpload?.name || "Not Selected"}
              </div>
            )}
            <div className="profileCard-b2-resume-m2">
              {" "}
              <Button
                component="label"
                role={undefined}
                variant="outlined"
                tabIndex={-1}
                startIcon={
                  <FileUploadOutlinedIcon
                    sx={{
                      color: "#165DFF",
                    }}
                  />
                }
                sx={{
                  borderColor: "#165DFF",
                  "&:hover": {
                    borderColor: "#165DFF",
                  },
                  " @media screen and (max-width: 625px)": {
                    width: "100%",
                  },
                }}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    color: "#165DFF",
                    width: "max-content",
                  }}
                >
                  Upload Resume
                </span>
                <VisuallyHiddenInput type="file" onChange={handleFileUpload} />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
